class TriageAnswer {
  constructor(title, hint, rank, triageQuestionId, nextTriageQuestionId) {
    this.title = title;
    this.hint = hint;
    this.rank = rank;
    this.triageQuestionId = triageQuestionId;
    this.nextTriageQuestionId = nextTriageQuestionId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      triageAnswer: new TriageAnswer('', '', null, null, null),
      allTriageAnswers: [],
    };
  },
  methods: {
    getAllTriageAnswers: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllTriageAnswers', this.previousQuestionId).then(() => {
        if (this.$store.state.triageAnswerModule.successFlag) {
          this.allTriageAnswers = this.$store.state.triageAnswerModule.allTriageAnswers;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllTriageAnswers();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllTriageAnswers();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllTriageAnswersByMissionId: function (missionId) {
      this.load.val = true;
      const params = {
        missionId,
      };
      this.$store
        .dispatch('getAllTriageAnswersByMissionIdDispatch', params)
        .then(() => {
          if (this.$store.state.triageAnswerModule.successFlag) {
            this.allTriageAnswers = this.$store.state.triageAnswerModule.allTriageAnswers;
          } else {
            if (this.$store.state.triageAnswerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllTriageAnswers();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.triageAnswerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllTriageAnswersByMissionId(missionId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    getQuestionWithAnswerIdFunction: function (answerId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getTriageAnswerByIdForGetQuestion', answerId).then(() => {
        if (this.$store.state.triageAnswerModule.successFlag) {
          let temp = this.$store.state.triageAnswerModule.triageAnswer;
          if (this.$route.name == 'triageQuestion') {
            if (temp.nextTriageQuestion) {
              this.triageQuestions = temp.nextTriageQuestion;
            } else {
              this.triageQuestions = null;
            }
          }
          if (this.$route.name == 'generalTriageQuestion') {
            if (temp.nextTriageQuestion) {
              this.generalTriageQuestions = temp.nextTriageQuestion;
            } else {
              this.generalTriageQuestions = null;
            }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getQuestionWithAnswerIdFunction(answerId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getQuestionWithAnswerIdFunction(answerId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addTriageAnswerFunction: function () {
      if (!this.triageAnswer.title) {
        this.snackText = 'پاسخ نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.triageAnswer.title.replace(/\s/g, '').length) {
        this.snackText = 'پاسخ نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.selectedGoTo) {
        if (!this.selectedGoToQuestion) {
          this.snackText = 'سوال را انتخاب نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      this.triageAnswer.triageQuestionId = Number(this.questionId);
      if (this.selectedGoTo) {
        if (this.selectedGoToQuestion) {
          this.triageAnswer.nextTriageQuestionId = Number(this.selectedGoToQuestion.id);
        } else {
          this.triageAnswer.nextTriageQuestionId = null;
        }
      } else {
        this.triageAnswer.nextTriageQuestionId = null;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addTriageAnswer', this.triageAnswer).then(() => {
        if (this.$store.state.triageAnswerModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.triageAnswer = new TriageAnswer('', '', null, null, null);
          let id = this.questionId;
          this.$router.push({ name: 'triageAnswer', params: { id: id } });
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addTriageAnswerFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addTriageAnswerFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getTriageAnswerFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getTriageAnswer', id).then(() => {
        if (this.$store.state.triageAnswerModule.successFlag) {
          let temp = this.$store.state.triageAnswerModule.triageAnswer;
          this.triageAnswer.title = temp.title;
          this.triageAnswer.hint = temp.hint;
          this.triageAnswer.rank = temp.rank;
          this.triageAnswer.id = temp.id;
          this.triageAnswer.triageQuestionId = this.questionId;
          this.triageAnswer.nextTriageQuestionId = temp.nextTriageQuestion
            ? temp.nextTriageQuestion.id
            : null;
          this.selectedGoTo =
            temp.nextTriageQuestion && temp.nextTriageQuestion.chiefComplaint
              ? temp.nextTriageQuestion.chiefComplaint
              : null;
          this.selectedGoToQuestion =
            temp.nextTriageQuestion && temp.nextTriageQuestion.chiefComplaint
              ? temp.nextTriageQuestion
              : null;
          if (temp.nextTriageQuestion && temp.nextTriageQuestion.chiefComplaint) {
            this.selectGoToItem(temp.nextTriageQuestion.chiefComplaint);
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getTriageAnswerFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getTriageAnswerFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editTriageAnswerFunction: function () {
      if (!this.triageAnswer.title) {
        this.snackText = 'پاسخ نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.triageAnswer.title.replace(/\s/g, '').length) {
        this.snackText = 'پاسخ نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.selectedGoTo) {
        if (!this.selectedGoToQuestion) {
          this.snackText = 'سوال را انتخاب نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      this.triageAnswer.triageQuestionId = Number(this.questionId);
      if (this.selectedGoTo) {
        if (this.selectedGoToQuestion) {
          this.triageAnswer.nextTriageQuestionId = Number(this.selectedGoToQuestion.id);
        } else {
          this.triageAnswer.nextTriageQuestionId = null;
        }
      } else {
        this.triageAnswer.nextTriageQuestionId = null;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editTriageAnswer', this.triageAnswer).then(() => {
        if (this.$store.state.triageAnswerModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.triageAnswer = new TriageAnswer('', '', null, null, null);
          let id = this.questionId;
          this.$router.push({ name: 'triageAnswer', params: { id: id } });
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editTriageAnswerFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editTriageAnswerFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteTriageAnswerFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteTriageAnswer', this.triageAnswerId).then(() => {
        if (this.$store.state.triageAnswerModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllTriageAnswers();
          this.snackText = ' پاسخ با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.triageAnswerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteTriageAnswerFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.triageAnswerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteTriageAnswerFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.triageAnswerModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
